import { Box, Container, Typography } from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { IconButton, Stack } from '@mui/material';

const Footer = () => {

    return (
        <Box
            sx={{
                mt: 8,
                py: 4,

                zIndex: 2,
                borderTop: "1px solid rgba(78,107,77,.2)",
                textAlign: "center",
                width: "100%",
            }}
        >
            <Typography
                sx={{
                    color: "#4e6b4d",
                    mb: 2,
                    fontSize: {
                        xs: "0.9rem",
                        md: "1rem",
                    }
                }}
            >
                Síguenos en nuestras redes sociales
            </Typography>

            <Stack
                direction="row"
                spacing={3}
                justifyContent="center"
            >
                <IconButton
                    component="a"
                    href="https://facebook.com"
                    target="_blank"
                    sx={{
                        color: "#347571",
                        transition: ".3s",

                        "&:hover": {
                            color: "#ffd700",
                            transform: "scale(1.15)",
                        }
                    }}
                >
                    <FacebookIcon sx={{ fontSize: 40 }} />
                </IconButton>

                <IconButton
                    component="a"
                    href="https://instagram.com"
                    target="_blank"
                    sx={{
                        color: "#347571",
                        transition: ".3s",

                        "&:hover": {
                            color: "#ffd700",
                            transform: "scale(1.15)",
                        }
                    }}
                >
                    <InstagramIcon sx={{ fontSize: 40 }} />
                </IconButton>
            </Stack>

            <Typography
                sx={{
                    mt: 3,
                    color: "#4e6b4d",
                    fontSize: ".85rem",
                }}
            >
                © {new Date().getFullYear()} Ready Cash. Todos los derechos reservados.
            </Typography>
        </Box>
    )

}

export default Footer